import { Button } from "../../Button";

import {
  Container,
  Content,
  DecorationLeft,
  DecorationRight,
  Description,
  Image,
  MainContent,
  Title,
} from "./styles";

export const Small = ({ image, title, description, buttonText }) => (
  <Container>
    <DecorationLeft />
    <Content>
      <Image src={image} alt="" />
      <MainContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Button>{buttonText}</Button>
      </MainContent>
    </Content>
    <DecorationRight />
  </Container>
);
